/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import { useParams } from "react-router-dom";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
// import { vacncsproperties } from "../../../data/vacancies";
// import { propertiesunitscampaigns } from "../../../data/guestcards";
import TextArea from "antd/es/input/TextArea";
import UnitTurnDetails from "./components/UnitTurnDetails";
import Maintenance from "./components/Maintenance";
import { auth, db } from "../../../../firebase";
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { Tag } from "antd";
import { useAuthState } from "react-firebase-hooks/auth";

function UnitTurnsItemPage() {
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [unitTurnsDataa, setUnitTurnsData] = useState([]);
  const [user, loading] = useAuthState(auth);
  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const { id } = useParams();
  console.log(id);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const getUnitTurn = async (id) => {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const userRef = collection(companyDocRef, "unitTurns");
    try {
      const docRef = doc(userRef, id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const unitTurnsData = docSnap.data();
        // Use the unitTurnsData as needed
        setUnitTurnsData(unitTurnsData);
        console.log("Unit Turns data:", unitTurnsData);
      } else {
        console.log("No matching document found");
      }
    } catch (error) {
      console.error("Error retrieving tenant:", error);
    }
  };

  const UnitTurnsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        <span>
          New Unit Turn
        </span>,
        "1",
        "",
        "",
        ""
      ),
      RightBarMethod(
        "New Recurring Work Order",
        "2",
        "",
        "",
        "/maintenance/recurring-work-orders/new"
      ),
    ]),

    RightBarMethod(
      " REPORTS",
      "t2",
      <i className="fa-solid fa-chart-column"></i>,
      [RightBarMethod("Unit Turn Detail", "3", "", "", "")]
    ),

    RightBarMethod(
      " HELP TOPICS",
      "t3",
      <i className="fa-solid fa-circle-question"></i>,
      [RightBarMethod("Using the Turn Board", "4", "", "", "/")]
    ),
  ];

  const gridStyle = {
    textAlign: "center",
  };
  useEffect(() => {
    if (!isCompanyNameFetched) return;
    console.log("useEffect", unitTurnsDataa.unitName);
    getUnitTurn(id);
  }, [companyName, isCompanyNameFetched]);
  return (
    <>
      <div>
        <PageHeading
          heading={
            <>
              Unit Turns {unitTurnsDataa?.unitName}{" "}
              <Tag style={{ background: "#333", color: "#fff" }}>
                {unitTurnsDataa?.status}
              </Tag>
            </>
          }
        />
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={UnitTurnsRightBar} />
      </div>
      <br />
      <UnitTurnDetails data={unitTurnsDataa} />
      <br />
      <Maintenance
        title="Maintenance / Repair"
        data={unitTurnsDataa}
        unitTurnId={id}
        type="Repair"
      />
      <br />
      <Maintenance
        title="Paint"
        data={unitTurnsDataa}
        unitTurnId={id}
        type="Paint"
      />
      <br />

      <Maintenance
        title="Appliances"
        data={unitTurnsDataa}
        unitTurnId={id}
        type="Appliances"
      />
      <br />

      <Maintenance
        title="Floors / Carpets"
        data={unitTurnsDataa}
        unitTurnId={id}
        type="Carpets"
      />
      <br />
      <Maintenance
        title="Other"
        data={unitTurnsDataa}
        unitTurnId={id}
        type="Other"
      />
      <br />
      <Maintenance
        title="Housekeeping"
        data={unitTurnsDataa}
        unitTurnId={id}
        type="Housekeeping"
      />
      <br />
      <Maintenance
        title="Keys / Locks"
        data={unitTurnsDataa}
        unitTurnId={id}
        type="Locks"
      />
      <br />
      <Maintenance
        title="Gutters"
        data={unitTurnsDataa}
        unitTurnId={id}
        type="Gutters"
      />
      <br />
      <Maintenance
        title="Exterior Paint"
        data={unitTurnsDataa}
        unitTurnId={id}
        type="ExteriorPaint"
      />
      <br />

      <Maintenance
        title="Pest Control"
        data={unitTurnsDataa}
        unitTurnId={id}
        type="PestControl"
      />
      <br />
      <Maintenance
        title="Windows"
        data={unitTurnsDataa}
        unitTurnId={id}
        type="Windows"
      />
      <br />
    </>
  );
}

export default UnitTurnsItemPage;
